export const AUTO_SYNC_ENABLED_CONNECTION_LABEL_TEXT = {
    message: 'Auto Sync is {prefix}',
    id: 'oe.common.connectionTemplate.autoSyncEnabled',
    description: 'Label text',
};

export const AUTOMATICALLY_RECORD_ENABLED_CONNECTION_LABEL_TEXT = {
    message: 'Automatically Record is {prefix}',
    id: 'oe.common.connectionTemplate.automaticallyRecordEnabled',
    description: 'Label text',
};